import React, { useEffect, useState } from "react";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { WISECURSOR_HERO_SLIDES } from "../waitlist/HeroBackgroundSlideshow";

const HomeHeroSlideshow = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [reduceMotion, setReduceMotion] = useState(false);

    useEffect(() => {
        const query = window.matchMedia?.("(prefers-reduced-motion: reduce)");
        if (!query) return undefined;
        const updatePreference = () => setReduceMotion(query.matches);
        updatePreference();
        query.addEventListener?.("change", updatePreference);
        return () => query.removeEventListener?.("change", updatePreference);
    }, []);

    useEffect(() => {
        if (isPaused || reduceMotion) return undefined;
        const interval = window.setInterval(() => {
            setActiveSlide((current) => (current + 1) % WISECURSOR_HERO_SLIDES.length);
        }, 7000);
        return () => window.clearInterval(interval);
    }, [isPaused, reduceMotion]);

    const selectSlide = (index) => setActiveSlide((index + WISECURSOR_HERO_SLIDES.length) % WISECURSOR_HERO_SLIDES.length);
    const paused = isPaused || reduceMotion;

    return (
        <>
            <div className="home-page__hero-slideshow" aria-hidden="true">
                {WISECURSOR_HERO_SLIDES.map((slide, index) => (
                    <div className={`home-page__hero-slide${index === activeSlide ? " is-active" : ""}${index > 0 ? " home-page__hero-slide--tinted" : ""}`} key={slide.src}>
                        <img
                            alt=""
                            decoding="async"
                            fetchpriority={index === 0 ? "high" : "auto"}
                            src={slide.src}
                            style={{ objectPosition: slide.position }}
                        />
                    </div>
                ))}
            </div>
            <div className="home-page__hero-controls" aria-label="Hero background slideshow controls">
                <button aria-label="Previous background image" onClick={() => selectSlide(activeSlide - 1)} type="button"><ChevronLeftRoundedIcon /></button>
                <div className="home-page__hero-dots" aria-label="Choose background image" role="group">
                    {WISECURSOR_HERO_SLIDES.map((slide, index) => (
                        <button
                            aria-current={index === activeSlide ? "true" : undefined}
                            aria-label={`Show background image ${index + 1}`}
                            className={index === activeSlide ? "is-active" : ""}
                            key={slide.src}
                            onClick={() => selectSlide(index)}
                            type="button"
                        />
                    ))}
                </div>
                {!reduceMotion && <button aria-label={isPaused ? "Play background slideshow" : "Pause background slideshow"} aria-pressed={isPaused} onClick={() => setIsPaused((value) => !value)} type="button">{paused ? <PlayArrowRoundedIcon /> : <PauseRoundedIcon />}</button>}
                <button aria-label="Next background image" onClick={() => selectSlide(activeSlide + 1)} type="button"><ChevronRightRoundedIcon /></button>
            </div>
        </>
    );
};

export default HomeHeroSlideshow;
